// @flow
import React, { useState } from 'react';
import classNames from 'classnames';
import { EventAnnouncementCard } from 'components/molecules/eventAnnouncementCard';
import type { ProjectAnnouncement } from 'types/project';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  data: ProjectAnnouncement,
  onClick: () => void,
  className?: string,
};

export const ProjectAnnouncementCard = (props: Props) => {
  const { data, onClick, className, ctaText } = props;
  const [imageLoaded, setImageLoaded] = useState(false);
  if (!data) {
    return null;
  }

  const setOnload = () => {
    setImageLoaded(true);
  };

  const containerClass = classNames('event-card', className);

  return (
    <div className={containerClass}>
      <>
        <img
          className={'full'}
          onLoad={setOnload}
          style={{
            animation: imageLoaded ? 'opacityAnimation 2000ms' : 'none',
          }}
          src={data.imageUrl}
          alt={'event-poster'}
        />
        <img
          className={'thumb'}
          src={data.thumbNailUrl}
          alt={'broken'}
          style={{
            visibility: imageLoaded ? 'hidden' : 'visible',
            position: 'absolute',
            left: '0',
          }}
        />
      </>
      <div className={'event-info'}>
        <EventAnnouncementCard
          data={data}
          onClick={onClick}
          ctaText={ctaText}
        />
      </div>
    </div>
  );
};
